/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const TurkishLira = [
  ["path", { d: "M15 4 5 9" }],
  ["path", { d: "m15 8.5-10 5" }],
  ["path", { d: "M18 12a9 9 0 0 1-9 9V3" }]
];

export { TurkishLira as default };
//# sourceMappingURL=turkish-lira.js.map
